export const ArticleDetail = () => {}
